import ShipmentStatusCard from './components/ShipmentStatusCard';
import { ShipmentStatusSummaryProps } from './types';
import { useNavigate } from 'react-router-dom';
import { useScrollMemory } from '@/hooks/use-scroll-restore';

const ShipmentStatusSummary = (props: ShipmentStatusSummaryProps) => {
  const {
    atWarehouseCount,
    customsCount,
    inTransitCount
  } = props;

  const navigate = useNavigate();
  const {
    saveCurrentScroll
  } = useScrollMemory();

  const onClickAtWarehouse = (): void => {
    saveCurrentScroll();
    navigate('/shipments?filter=at_warehouse');
  };

  const onClickCustoms = (): void => {
    saveCurrentScroll();
    navigate('/shipments?filter=at_customs');
  };

  const onClickInTransit = (): void => {
    saveCurrentScroll();
    navigate('/shipments?filter=in_transit');
  };

  return (
    <section className="flex w-full items-center gap-2">
      <ShipmentStatusCard
        count={inTransitCount}
        onClick={onClickInTransit}
        type="inTransit"
      />
      <ShipmentStatusCard
        count={customsCount}
        onClick={onClickCustoms}
        type="customs"
      />
      <ShipmentStatusCard
        count={atWarehouseCount}
        onClick={onClickAtWarehouse}
        type="atWarehouse"
      />
    </section>
  );
};

export default ShipmentStatusSummary;